<script setup lang="ts">
import { Skeleton } from '@laam/ui/base';
const deviceType = inject('deviceType') as Ref<string | undefined>;
</script>

<template>
	<div class="flex flex-row items-center justify-start w-full">
		<div
			v-for="i in deviceType === 'mobile' ? 2 : 4"
			:key="i"
			class="flex flex-row min-w-[156px]"
		>
			<div
				class="product_card relative flex flex-col h-[300px] w-full pr-2xl pl-0"
			>
				<Skeleton class="w-[170px] lg:w-[200px] h-[240px] rounded-xs" />
				<div class="flex flex-col py-md gap-xs">
					<div class="flex justify-between items-start">
						<Skeleton class="w-[90px] h-[16px] rounded-full" color="dark" />
						<Skeleton class="w-[20px] h-[20px]" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
